import { render, staticRenderFns } from "./FileSystemCreate.vue?vue&type=template&id=77f36c22"
import script from "./FileSystemCreate.vue?vue&type=script&lang=js"
export * from "./FileSystemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports